import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Link } from 'components/Common';
import ImageContainer from 'components/ImageContainer';

import { imageBorderRadius } from 'themes';

export const ITEM_WIDTH = 132;
const MARGIN_WIDTH = 8;

const AppImage = `
  background-position: center;
  border-radius: ${imageBorderRadius};
  margin: ${MARGIN_WIDTH}px;
  width: ${ITEM_WIDTH - 2 * MARGIN_WIDTH}px;
`;

const AppTitle = styled.div`
  font-size: 14px;
  height: 34px;
  letter-spacing: -0.4px;
  margin: 0;
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: ${ITEM_WIDTH}px;
`;

const LinkItem = styled(Link)`
  display: inline-block;
  width: ${ITEM_WIDTH}px;
  user-drag: none;
  img {
    border-radius: ${imageBorderRadius};
  }
`;

const CarouselItem = ({ app, ...props }) => {
  const [banner] = app.banners;
  const imageUrl = banner.uri;

  return (
    <LinkItem
      to={`/clock/${app.id}`}
      pageDirection="FORWARD"
      data-test-type="clock-link"
      data-test-id={app.id}
      {...props}
    >
      <ImageContainer
        containerAttr={{
          styles: AppImage,
          width: banner.width,
          height: banner.height
        }}
        imageAttr={{
          alt: app.name,
          src: imageUrl,
          draggable: false
        }}
      />
      <AppTitle>{app.name}</AppTitle>
    </LinkItem>
  );
};

CarouselItem.propTypes = {
  app: PropTypes.shape({
    icon: PropTypes.shape({
      uri: PropTypes.string.isRequired
    }),
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
  }).isRequired
};

export default CarouselItem;
